import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-block',
  templateUrl: './action-block.component.html',
  styleUrls: ['./action-block.component.scss'],
})
export class ActionBlockComponent {
  @Input() actionName = '';
  @Input() actionDesc = '';
  @Input() actionButtonText = '';
  @Output() actionButtonClicked = new EventEmitter<void>();

  constructor(){

  }

  ngOnInit(){

  }

  emitClick($event){
    if(this.actionName =="Claim Breakdown"){
      this.actionButtonClicked.emit($event);
    }
    if(this.actionName =="Need Help?"){
      this.actionButtonClicked.emit($event);
    }
    if(this.actionName =="Payment Details"){
      this.actionButtonClicked.emit($event);
    }
    if(this.actionName =="View Letter"){
      this.actionButtonClicked.emit($event);
    }
  }

  openClaimBreakdownPopup(){

  }
}
